import axios from 'axios'
import { urlApiCierre, urlMyspreadApi, urlApiFunctionPlanning } from './urls'

import { getConfigWithUserEmail, basicAuthConfig } from './configs'
import { formatDate } from '../date'

// Function to get mantenedores cierre
export const getMantenedores = async (tipo, currentUser) => {
    let url = urlApiCierre + 'api/mantenedores/?' + tipo + '=true'
    const configWithUserEmail = getConfigWithUserEmail(currentUser)

    try {
        const response = await axios.get(url, configWithUserEmail)
        return response.data // Retorna los datos obtenidos
    } catch (error) {
        return error.response ? { error: error.response.data.message } : { error: 'Error desconocido' }
    }
}

// Function to get extras por bono
export const extrasPorBono = async (type, currentUser, params) => {
    let url = urlApiCierre + 'api/bonos/?type=' + type + '&' + params
    const configWithUserEmail = getConfigWithUserEmail(currentUser)

    try {
        const response = await axios.get(url, configWithUserEmail)
        return response.data // Retorna los datos obtenidos
    } catch (error) {
        return error.response ? { error: error.response.data.message } : { error: 'Error desconocido' }
    }
}

// Función para obtener los datos de control de gestión
export const getControlGestion = async (tipo, startDate, endDate, currentUser) => {

    startDate = formatDate(startDate)
    endDate = formatDate(endDate)
    // startDate = '2025-03-25'
    // endDate = '2025-03-31'
    let url = urlMyspreadApi + 'controlgestion/' + tipo + '?fecha_inicio=' + startDate + '&fecha_fin=' + endDate + '&recepcionado=true'

    try {
        const response = await axios.get(url, basicAuthConfig(currentUser))
        // console.log('Response:', response); // Log de la respuesta
        if (response.status !== 200) {
            throw new Error('Error al obtener los datos de control de gestión')
        }
        return response.data // Retorna los datos obtenidos
    } catch (error) {
        console.error('Error:', error) // Log del error
        return error.response ? { error: error.response.data.message } : { error: 'Error desconocido' }
    }
}

// Function to get guías by date and status
export const getGuiasFechaEstado = async (tipo, params, currentUser) => {
    const { recepcion_date, guia_status, start_date, end_date } = params;

    // Validate mutually exclusive parameters
    if (recepcion_date && (start_date || end_date)) {
        throw new Error("'recepcion_date' cannot be used with 'start_date' and 'end_date'.");
    }

    // Validate start_date and end_date presence
    if ((start_date && !end_date) || (!start_date && end_date)) {
        throw new Error("Both 'start_date' and 'end_date' must be provided together.");
    }

    // Construct the base URL
    let url = `${urlMyspreadApi}controlgestion/filter_guides?`;

    // Add parameters to the URL
    if (recepcion_date) {
        url += `recepcion_date=${recepcion_date}&`;
    }
    if (guia_status) {
        url += `guia_status=${guia_status}&`;
    }
    if (start_date && end_date) {
        url += `fecha_inicio=${start_date}&fecha_fin=${end_date}&`;
    }

    // Remove trailing '&' or '?' if present
    url = url.replace(/[&?]$/, '');

    try {
        const response = await axios.get(url, basicAuthConfig(currentUser));
        if (response.status !== 200) {
            throw new Error('Error al obtener los datos de control de gestión');
        }
        return response.data; // Return the obtained data
    } catch (error) {
        console.error('Error:', error); // Log the error
        return error.response ? { error: error.response.data.message } : { error: 'Error desconocido' };
    }
};

// Function to get guías masivas
export const getGuiasMasivas = async (tipo, params, currentUser) => {
    let url = urlMyspreadApi + 'controlgestion/search_guides';
    // Build the request body
    const body = {};
    if (params && params.guide_numbers) body.guide_numbers = params.guide_numbers;
    if (params && params.options) body.options = params.options;
    if (params && params.type_of_search) body.type_of_search = params.type_of_search;
    try {
        const response = await axios.post(url, body, basicAuthConfig(currentUser));
        if (response.status !== 200) {
            throw new Error('Error al obtener los datos de guías individuales');
        }
        return response.data; // Retorna los datos obtenidos
    } catch (error) {
        console.error('Error:', error); // Log del error
        return error.response ? { error: error.response.data.message } : { error: 'Error desconocido' };
    }
}

// Function to get all statuses from the database
export const getAllStatuses = async (currentUser, tipo_mantenedor, tipo_estado) => {
    let url = urlMyspreadApi + 'mantenedores/search/' + tipo_mantenedor + '?'
    if (tipo_estado) {
        url += '&tipo_estado=' + encodeURIComponent(tipo_estado)
    }
    try {
        const response = await axios.get(url, basicAuthConfig(currentUser))
        if (response.status === 200 && response.data.message === 'Success') {
            return response.data.data
        }
        return null
    } catch (error) {
        console.error('Error fetching statuses:', error)
        return null
    }
}

// Function to create a new status
export const createStatus = async (currentUser, table, statusData) => {
    let url = urlMyspreadApi + 'mantenedores/create/'+ table;
    try {
        const response = await axios.post(url, statusData, basicAuthConfig(currentUser))
        // Return the full response so caller can check status and data
        return response
    } catch (error) {
        console.error('Error creating status:', error)
        return null
    }
}

// Function to delete a status (softDelete)
export const deleteStatus = async (currentUser, tipoTabla, statusId) => {
    let url = urlMyspreadApi + 'mantenedores/delete/' + tipoTabla + '/' + statusId;
    try {
        const response = await axios.delete(url, basicAuthConfig(currentUser));
        // Return the full response so caller can check status and data
        return response;
    } catch (error) {
        console.error('Error deleting status:', error);
        return null;
    }
}

// Function to update a status (PATCH, partial update, e.g. restore or other fields)
export const restoreStatus = async (currentUser, tipoTabla, statusId, updateFields = { softDelete: false }) => {
    let url = urlMyspreadApi + 'mantenedores/' + tipoTabla + '/' + statusId;
    try {
        // PATCH is best for partial updates (e.g., just softDelete or more fields)
        const response = await axios.patch(url, updateFields, basicAuthConfig(currentUser));
        return response;
    } catch (error) {
        console.error('Error updating status:', error);
        return null;
    }
}

// Function to syncronize receptions
export const syncReceptions = async (currentUser, date) => {
    // Validate date format
    if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        throw new Error('Invalid date format. Expected format: YYYY-MM-DD');
    }
    console.log('Syncing receptions for date:', date)
    let base_url = urlApiFunctionPlanning
    let url = `${base_url}api/consolidado_recepciones?fecha=${date}`
    console.log('url: ', url)
    try {
        const response = await axios.get(url, basicAuthConfig(currentUser))
        // Optionally handle response here (for now, just log)
        console.log('Sync response:', response)
        return response.data
    } catch (error) {
        console.error('Error syncing receptions:', error)
        return error.response ? { error: error.response.data.message } : { error: 'Error desconocido' }
    }
}